import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AboutAgency from './components/AboutAgency';
import FloatingActions from './components/FloatingActions';
import EcosystemFlow from './components/EcosystemFlow';

import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <div
      className="
        App min-h-screen overflow-x-hidden font-sans
        bg-slate-200 text-slate-600
        dark:bg-slate-950 dark:text-slate-200
        selection:bg-primary/20 selection:text-secondary
      "
    >
      <Header />

      <main>
        <Hero />
        <EcosystemFlow />
        <AboutAgency />
        <Team />
        <Services />
        <Portfolio />
        <Contact />
      </main>

      <Footer />

      {/* ✅ Botones flotantes globales (WhatsApp + Ir arriba) */}
      <FloatingActions />

      {/* ✅ Banner de cookies al cargar el sitio */}
      <CookieConsent />
    </div>
  );
}

export default App;